import React from "react";
import { Result, Button } from "lib/ui";
import { Link } from "react-router-dom";

const NotFound = () => {
  return (
    <div className="flex min-h-[min(70vh,calc(100vh-8rem))] flex-col items-center justify-center py-16">
      <div className="w-full max-w-lg rounded-2xl border border-slate-200/80 bg-white px-6 py-10 shadow-card ring-1 ring-slate-900/[0.04]">
        <Result
          status="404"
          title="404"
          subTitle="Sorry, the page you visited does not exist."
          extra={
            <Link to="/">
              <Button type="primary">Back to dashboard</Button>
            </Link>
          }
        />
      </div>
    </div>
  );
};

export default NotFound;
